let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hmlb0")).then(() => parcelRequire('8nSrm'));